import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { fetchBulkUploadRequest } from '../../../api/bulkUpload/bulkUploadSlice';
import useSubscriptionCheck from '../../common/SubscriptionCheck';
import BulkUploadButtonAction from './BulkUploadButtonAction';

function BulkUploadListPageActions() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();
  const subscription = useSelector((state) => state.org.org.subscription);
  const isBulkUploadFeatureEnabled = subscription?.features?.enable_bulk_upload;
  const isSftpFeatureEnabled = subscription?.features?.enable_sftp;

  const handleOpen = () => {
    if (!checkSubscription()) {
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    dispatch(fetchBulkUploadRequest({ query: { page: 1, limit: 10 } })); // Refresh the list on modal close
  };

  return (
    <>
      {(isBulkUploadFeatureEnabled || (isSftpFeatureEnabled && isBulkUploadFeatureEnabled)) && (
        <Button id="bulk-upload" variant="contained" color="primary" onClick={handleOpen}>
          + Bulk Upload
        </Button>
      )}
      <BulkUploadButtonAction open={open} onCancel={handleClose} document_type="e_invoice" />
      <SubscriptionModal />
    </>
  );
}

export default BulkUploadListPageActions;
